var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMinimise(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.795 1.19497C14.0683 0.921608 14.0683 0.478392 13.795 0.205025C13.5216 -0.0683418 13.0784 -0.0683418 12.805 0.205025L9.8 3.21005L9.8 2.1C9.8 1.7134 9.4866 1.4 9.1 1.4C8.7134 1.4 8.4 1.7134 8.4 2.1L8.4 4.9C8.4 5.2866 8.7134 5.6 9.1 5.6L11.9 5.6C12.2866 5.6 12.6 5.2866 12.6 4.9C12.6 4.5134 12.2866 4.2 11.9 4.2H10.7899L13.795 1.19497ZM0.205025 13.795C-0.0683418 13.5216 -0.0683417 13.0784 0.205025 12.805L3.21005 9.8H2.1C1.7134 9.8 1.4 9.4866 1.4 9.1C1.4 8.7134 1.7134 8.4 2.1 8.4H4.9C5.2866 8.4 5.6 8.7134 5.6 9.1L5.6 11.9C5.6 12.2866 5.2866 12.6 4.9 12.6C4.5134 12.6 4.2 12.2866 4.2 11.9L4.2 10.79L1.19497 13.795C0.921608 14.0683 0.478392 14.0683 0.205025 13.795Z",
    fill: "#6E6E73"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinimise);
export default __webpack_public_path__ + "static/media/minimise.275cfe5919941cfd9c21bca6bfe22dbb.svg";
export { ForwardRef as ReactComponent };